<template>
  <v-dialog v-model="dialog" width="640px">
    <v-card>
      <v-card-title class="mx-3">
        {{ $t('StockOrderOUT.manualSplit.confirm') }}
        <v-spacer />
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          <span>{{ $t("$vuetify.close") }}</span>
        </v-tooltip>
      </v-card-title>

      <v-card-text>
        <v-container>
          <ValidationObserver ref="observer">
            <v-form>
              <v-row>
                <!-- 实际发生时间-->
                <v-col cols="3">
                  <span>{{ $t("StockOrderOUT.Fields.actual_time") }}</span>
                </v-col>
                <v-col cols="6">
                  <ValidationProvider
                          v-slot="{ errors }"
                          :name="$t('StockOrderOUT.Fields.actual_time')"
                          rules="required"
                  >
                    <SearcherDatetime
                            class="my-n2"
                            v-model="actualDate"
                            type="datetime"
                            single-line
                            dense
                            hide-details
                            hide-icon
                            required
                            :errors="errors"
                            readonly
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </SearcherDatetime>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </v-form>
          </ValidationObserver>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" outlined @click="dialog = false">{{ $t("$vuetify.close") }}</v-btn>
        <v-btn color="primary" @click="doSubmit()" >{{ $t("StockOrderOUT.manualSplit.confirm") }}</v-btn>
      </v-card-actions>


    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import SearcherDatetime from "@/components/plugins/SearcherDatetime";


export default {
  name: "DialogManualSplit",

  components: {
    ValidationObserver,
    ValidationProvider,
    SearcherDatetime,
  },

  props: {
    value: Boolean,
  },

  computed: {
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    dialog: false,
    actualDate: "",
  }),

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.dialog = this.value;
        if (this.dialog) {
          this.actualDate = this.$datetimeUtils.formatTime(new Date())
        }
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
      },
    },
  },

  methods: {
    doSubmit() {
      this.$refs.observer.validate().then(
              async function (result) {
                if (result) {
                  this.$emit("confirm", this.actualDate);
                }
              }.bind(this)
      )
    }
  },
};
</script>
